var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLetterIconcom = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.33349 7.503763L14.418156 12l5.915334 4.495767V7.503763zm-1.1016 9.829257l-5.915333-4.495767-.30762.233302c-.604421.459548-1.412041.460019-2.016463 0l-.30809-.233302L4.76905 17.33302h14.46284zm-15.56444-.837253L9.583256 12 3.66745 7.503763v8.992004zm1.1016-9.829257l7.029633 5.342427c.12794.097366.275635.097366.403575 0L19.23189 6.66651H4.76905zM20.66698 5C21.401223 5 22 5.598777 22 6.33349v11.33255c0 .734713-.598777 1.33349-1.33302 1.33349H3.33396C2.599247 18.99953 2 18.400753 2 17.66604V6.33349C2 5.598777 2.599247 5 3.33396 5h17.33302z",
  fill: "#FFF",
  fillRule: "evenodd"
})));
export default SvgLetterIconcom;